import React from "react";
import { useLang } from "@/context/LangContext";

export default function Marquee() {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-[#0E1F18] py-5 overflow-hidden select-none"
    >
      <div className="marquee-track flex whitespace-nowrap">
        {[0, 1].map((k) => (
          <span
            key={k}
            className="font-mono text-lg sm:text-xl tracking-[0.15em] text-white/45 pr-8"
          >
            {`${text} ${text} `}
          </span>
        ))}
      </div>
    </div>
  );
}
